module.exports = __webpack_public_path__ + "img/products-details.2756f618.jpg";